import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ service, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={`${service.span} min-h-[380px]`}
      data-testid={`service-card-${service.slug}`}
    >
      <Link
        to={`/services/${service.slug}`}
        className="group relative flex flex-col justify-end h-full overflow-hidden border border-[#27272a] hover:border-gold/50 transition-colors duration-500"
      >
        <div className="absolute inset-0">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover opacity-45 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/60 to-[#0a0a0a]/10" />
        </div>

        <div className="absolute top-6 left-6 right-6 flex items-start justify-between">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">
            {service.number} / {service.category}
          </span>
          <span className="h-10 w-10 grid place-items-center rounded-full border border-white/20 text-white group-hover:bg-gold group-hover:text-black group-hover:border-gold transition-all duration-300">
            <ArrowUpRight size={18} />
          </span>
        </div>

        <div className="relative p-6 lg:p-8">
          <h3 className="font-display text-2xl lg:text-3xl font-semibold tracking-tight leading-tight">
            {service.title}
          </h3>
          <p className="text-zinc-400 text-sm mt-3 max-w-md leading-relaxed">
            {service.tagline}
          </p>
          <div className="mt-5 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-white">
            {service.priceLabel ? (
              <span className="text-gold">{service.priceLabel}</span>
            ) : (
              <>
                <span className="text-zinc-500">from</span>
                <span className="text-gold">{service.tiers[0].price}</span>
              </>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
